<script>
	// 아바톡(봇) 빌더 좌측 섹션 네비게이션. 탭 로직은 bot(Bot 인스턴스)이 소유 — 여긴 표현만.
	// chat-builder/shell/BuilderSidebar와 같은 shadcn(--sb 토큰/tw-) 룩. 봇 전용 탭·유틸 메뉴.
	export let bot;
	export let tabList = []; // 이미 enterprise 필터가 적용된 목록(부모에서 계산)

	// lucide 스타일 아이콘(내부 마크업만; svg 래퍼는 공통)
	const icons = {
		// 기본(허브) — 집. 허브를 새로 만들면 여기부터 채운다
		hubBasic:
			'<path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>',
		// 관리자(허브) — 사람들. 납품처 기관·운영자 계정을 다룬다
		hubOrgs:
			'<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>',
		// 메인 섹션 구성 — 대화 말풍선
		scenario:
			'<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>',
		// 채팅(허브) — 격자. 같은 'contents' 자리지만 허브는 링크가 아니라 카드 격자를 다룬다
		hubContents:
			'<rect width="7" height="7" x="3" y="3" rx="1"/><rect width="7" height="7" x="14" y="3" rx="1"/><rect width="7" height="7" x="14" y="14" rx="1"/><rect width="7" height="7" x="3" y="14" rx="1"/>',
		// 고정 콘텐츠 / 페이지 — 링크
		contents:
			'<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>',
		// 이미지 에셋 — 이미지
		imageAsset:
			'<rect width="18" height="18" x="3" y="3" rx="2" ry="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/>',
		// 디자인 — 붓
		pageDesign:
			'<path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"/>',
		// 통계 — 막대그래프
		statistics:
			'<line x1="12" x2="12" y1="20" y2="10"/><line x1="18" x2="18" y1="20" y2="4"/><line x1="6" x2="6" y1="20" y2="16"/>',
		// 사용량·비용(허브) — 동전. 담긴 챗들의 AI 사용량·추정 비용
		hubUsage:
			'<circle cx="8" cy="8" r="6"/><path d="M18.09 10.37A6 6 0 1 1 10.34 18"/><path d="M7 6h1v4"/><path d="m16.71 13.88.7.71-2.82 2.82"/>',
		// 설정 — 톱니바퀴
		statisticsManagement:
			'<path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/>',
		// 수집 — 수신함
		customerResponse:
			'<path d="M22 12h-6l-2 3h-4l-2-3H2"/><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>',
	};
</script>

<!-- 폰(<md=768px)은 상단 가로 탭(BuilderTopTabs)으로 대체 → 여기선 숨김.
     태블릿(md~lg)은 아이콘 레일(56px), 데스크톱(≥lg=1024px)은 풀 사이드바(220px). -->
<aside class="tw-hidden tw-w-14 tw-shrink-0 tw-flex-col tw-border-r tw-border-border tw-bg-sidebar tw-font-sans md:tw-flex lg:tw-w-[220px]">
	<!-- 단계 nav -->
	<nav class="tw-flex tw-flex-1 tw-flex-col tw-gap-1 tw-px-2 tw-pt-4 lg:tw-px-3">
		<div class="tw-hidden tw-px-2 tw-pb-1 tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wide tw-text-muted-foreground lg:tw-block">
			빌더 단계
		</div>
		{#each tabList as tab (tab.value)}
			<button
				type="button"
				title={tab.label}
				class="tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-gap-2.5 tw-rounded-lg tw-px-2.5 tw-py-2 tw-text-left tw-text-sm tw-transition-colors lg:tw-justify-start {bot.isCurrentTab(
					tab.value,
				)
					? 'tw-bg-primary/10 tw-font-semibold tw-text-primary'
					: 'tw-text-foreground/70 hover:tw-bg-muted hover:tw-text-foreground'}"
				on:click={() => bot.changeCurrentTab(tab.value)}
			>
				<svg
					class="tw-h-[18px] tw-w-[18px] tw-shrink-0"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				>
					{@html icons[tab.icon || tab.value] || ""}
				</svg>
				<span class="tw-hidden tw-flex-1 lg:tw-block">{tab.label}</span>
				{#if tab.required}
					<span class="tw-hidden tw-text-xs tw-text-destructive lg:tw-inline">*</span>
				{/if}
			</button>
		{/each}
	</nav>
</aside>
